import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-activity-details',
	templateUrl: './activity-details.component.html',
	styleUrls: ['./activity-details.component.scss']
})
export class ActivityDetailsComponent implements OnInit {
	@Input() data: any;
	@Input() stepper_stage: any;
	@Output() activityDetailsClosed = new EventEmitter<any>();
  user_details: any;

	constructor(
		public commonService: CommonService,
		private datePipe: DatePipe,
    	private storageService: StorageService,
	) { }

	ngOnInit(): void {
    this.user_details = this.storageService.get("user_details");
		if (this.data != null) {
			// this.getActivityData();
		} else {

		}

		this.getStatusList();
		this.getConversionStatusList();
		this.getCommunicationTypes();
		this.getTaggingUsers();
		this.getAFA();

		this.getProductList();
		this.getClientProductStatus();

		this.getStages();
	}

	activity_data: any = {};
	activity_data_loaded: boolean = false;
	getActivityData() {
		this.activity_data_loaded = false;
		this.commonService.getData('//?id=' + this.data.id).subscribe(
			(res: any) => {
				this.activity_data = res["data"];
				this.activity_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	close() {
		this.activityDetailsClosed.emit("Closed");
	}

	conversion_status_list: any = [];
	getConversionStatusList() {
		this.commonService.getData('/conversionStatus/?no_page=true').subscribe(
			(res: any) => {
				this.conversion_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatusList() {
		this.commonService.getData('/status/?no_page=true').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	communication_type_list: any = [];
	getCommunicationTypes() {
		this.commonService.getData('/communicationType/?no_page=true').subscribe(
			(res: any) => {
				this.communication_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	tagging_users_list: any = [];
	getTaggingUsers() {
		this.commonService.getData("/taguserslist/").subscribe(
			(res: any) => {
				this.tagging_users_list = res;
			},
			(err) => {
				this.commonService.showToast("error", err.error);
			}
		)
	}

	afa_list: any = [];
	getAFA() {
		this.commonService.getData('/getassistants').subscribe(
			(res: any) => {
				this.afa_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_list: any = [];
	getProductList() {
		this.commonService.getData('/product/?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
		(res: any) => {
			this.product_list = res;
		},
		(err) => {
			this.commonService.showToast('error', err.error);
		},
		);
	}

	client_product_status_list: any = [];
	getClientProductStatus() {
			this.commonService.getData('/clientProductStatus/?no_page=true').subscribe(
			(res: any) => {
				this.client_product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getProductType(id) {
		const index = this.product_list.findIndex((x) => x.id == id);
		if (index > -1) {
			// this.product_data.product_type = this.product_list[index].product_type;
			if (this.product_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	stages_list: any = [];
	getStages() {
		// let route: any = '/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + "&business_area=" + this.user_details.role.business_area[0];
		let route: any = '/stage?no_page=true&business_area=' + this.user_details.role.business_area[0];
		if (this.stepper_stage) {
			route = route + "&current_stage=" + this.stepper_stage.id + "&type=" + this.stepper_stage.type;
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
        		this.stages_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	editable_field: any = "";
	toggleEditableFields(value) {
		if (this.editable_field == value) {
			this.editable_field = "";
		} else {
			this.editable_field = value;
		}
	}

	activity_tab_selected: any = "Comments";

}
